import "bootstrap-icons/font/bootstrap-icons.css";

import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import { Link } from "react-router-dom";

import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronBiz } from "sections";
import { eligibility } from "constants/eligibility";
import { LinkButton } from "components/buttons";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import outline_check from "assets/images/outline_check.svg";
import DepositImage from "assets/images/hero-images/Banner_Deposit.png";
import BG from "assets/images/hero-images/BG.png";

function TermDeposit() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronBiz
          badgeText="Deposits"
          title={`Commodity Murabahah<br>
              <span className="jumbotron-subtitle-2">
                Term Deposit-<i>i</i>
              </span>`}
          buttonText="Reach out to us!"
          footNotes="Protected by PIDM up to RM250,000 for each depositor"
          backgroundImage={DepositImage}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Our Commodity Murabahah Term Deposit-<em>i</em>  is a
              Shariah-compliant financial solution for effectively managing your
              cash reserves. It provides businesses with an opportunity to earn
              competitive returns while adhering to Islamic financial
              principles. Start exploring how our Commodity Murabahah Term
              Deposit-<em>i</em> can enhance your business’s financial strategy.
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Minimum deposit</div>
                <div className="column-subheader-2">
                  Enjoy a minimum deposit of RM500{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Flexible tenure</div>
                <div className="column-subheader-2">
                  Flexible tenure up to 60 months{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Guaranteed principle</div>
                <div className="column-subheader-2">
                  Guaranteed principle with fixed profit{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Standard</div>
                <div className="column-subheader-2">
                  In compliance with alrajhi bank Malaysia’s Shariah standard{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah Contract</div>
                <div className="column-subheader-2">
                  Commodity Murabahah (via Tawarruq arrangement){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitytdbiz.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
            <div className="link-button-row" style={{ paddingTop: "100px" }}>
              <LinkButton
                text="Profit Rate"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/1689144711_Board Profit Rate 080723.pdf"
                  )
                }
              />
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <LinkButton
                text="Fees and Charges"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/fees_and_charges.pdf"
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/1571298441_TD-i PDS V2_2019.pdf"
                  )
                }
              />
              {/* <LinkButton
                text="Opening / Placement Form"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/TDi_Opening_Placement Form.pdf"
                  )
                }
              />
              <LinkButton
                text="Agency Appointment Form"
                onClick={() =>
                  window.open(
                    "https://www.alrajhibank.com.my/assets/pdf/deposits/TDi_Agency Appoinment Form.pdf"
                  )
                }
              /> */}
            </div>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Reach out to us! </h3>
            <p>
              Share your details, and we'll get back to you as soon as possible.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermDeposit;
